import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'aid-display-data',
  template: `
    @if (!isInput) {
      <div
        class="aid-layout-gap-8"
        [ngClass]="labelLayoutClasses"
      >
        <div
          [ngClass]="{
            floating__label: type === 'floating',
            label: type === 'inline'
            }"
        >
          {{ label | translate }}{{ type === 'inline' ? ':' : '' }}
        </div>
        <div
          class="aid-layout-row aid-layout-align-start-center aid-layout-gap-8"
        >
          @if (!values) {
            <div class="label mat-subtitle-2">
              @if (translate) {
                {{ (value | translate) || '-' }}
              }
              @if (!translate) {
                {{ value || '-' }}
              }
            </div>
          }
          @if (image) {
            <aid-avatar [image]="image"></aid-avatar>
          }
        </div>
        @if (values) {
          <div>
            @for (value of values; track value) {
              <div class="label mat-subtitle-2">
                {{ value }}
              </div>
            }
            @if (values.length === 0) {
              <div>
                -
              </div>
            }
          </div>
        }
      </div>
    }
    @if (isInput) {
      <mat-form-field class="full-width">
        <mat-label> {{ label | translate }}</mat-label>
        <input matInput disabled [value]="value" />
      </mat-form-field>
    }
    `,
  styleUrls: ['./display-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DisplayDataComponent implements OnInit {
  @Input() label?: string;
  @Input() value?: string | null;
  @Input() image?: string;
  @Input() values?: string[] | null;
  @Input() translate?: boolean;
  @Input() type: 'inline' | 'floating' | 'input' = 'inline';

  constructor() {}

  ngOnInit() {}

  get labelLayoutClasses(): string[] {
    return this.type === 'inline'
      ? ['aid-layout-row', 'aid-layout-align-start-center']
      : ['aid-layout-column', 'aid-layout-align-start-start'];
  }

  get isInput() {
    return this.type === 'input';
  }
}
